import { render, staticRenderFns } from "./EmailStep.vue?vue&type=template&id=b52a3d70&scoped=true"
import script from "./EmailStep.vue?vue&type=script&setup=true&lang=ts"
export * from "./EmailStep.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./EmailStep.vue?vue&type=style&index=0&id=b52a3d70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b52a3d70",
  null
  
)

export default component.exports